import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useCart } from "../lib/cart";
import { ChevronLeft, ShoppingBag, Check } from "lucide-react";

export default function Product() {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [variant, setVariant] = useState("");
  const [added, setAdded] = useState(false);
  const { add } = useCart();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    api.get(`/products/${slug}`).then((r) => {
      setProduct(r.data);
      setVariant(r.data.variants?.[0] || "");
    }).finally(() => setLoading(false));
  }, [slug]);

  const handleAdd = () => {
    if (!product) return;
    if (product.variants?.length > 0 && !variant) return;
    add(product, variant, 1);
    setAdded(true);
    setTimeout(() => setAdded(false), 1800);
  };

  if (loading) return <div className="py-32 text-center font-mono-label">CHARGEMENT…</div>;
  if (!product) return (
    <div className="py-24 max-w-2xl mx-auto text-center">
      <h1 className="font-display text-4xl">Produit introuvable</h1>
      <Link to="/boutique" className="font-mono-label text-[#4A7A3D] inline-block mt-4">← Retour à la boutique</Link>
    </div>
  );

  return (
    <div data-testid="product-page" className="border-b border-[#E0D8CE]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <Link to="/boutique" className="font-mono-label flex items-center gap-1 mb-8 hover:text-[#4A7A3D]" data-testid="product-back">
          <ChevronLeft size={14} /> Boutique
        </Link>
        <div className="grid md:grid-cols-2 gap-10 md:gap-16">
          <div className="aspect-square bg-[#F5EFEB] border border-[#E0D8CE] overflow-hidden">
            {product.image && <img src={product.image} alt={product.name} className="w-full h-full object-cover" />}
          </div>
          <div className="flex flex-col justify-center">
            <span className="font-mono-label text-[#4A7A3D]">{product.category?.toUpperCase()}</span>
            <h1 className="font-display text-4xl md:text-6xl leading-[1.0] mt-3">{product.name}</h1>
            <div className="font-display text-3xl md:text-4xl text-[#4A7A3D] mt-6">{product.price}</div>
            <p className="text-[#4B4B48] mt-6 leading-relaxed">{product.description}</p>

            {product.variants?.length > 0 && (
              <div className="mt-8">
                <div className="font-mono-label text-[#4B4B48] mb-3">Taille</div>
                <div className="flex flex-wrap gap-2">
                  {product.variants.map((v) => (
                    <button
                      key={v}
                      onClick={() => setVariant(v)}
                      className={`min-w-[3rem] px-4 py-2 border-2 font-mono-label ${variant === v ? "bg-[#1A1A18] text-[#FAF8F3] border-[#1A1A18]" : "border-[#E0D8CE] hover:border-[#1A1A18]"}`}
                      data-testid={`product-variant-${v}`}
                    >
                      {v}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <button
                onClick={handleAdd}
                disabled={!product.in_stock}
                className="bg-[#4A7A3D] text-[#FAF8F3] px-8 py-4 font-mono-label hover:bg-[#3E6633] disabled:opacity-50 flex items-center justify-center gap-2"
                data-testid="product-add-cart"
              >
                {added ? <><Check size={16} /> Ajouté !</> : <><ShoppingBag size={16} /> Ajouter au panier</>}
              </button>
              <button
                onClick={() => { handleAdd(); navigate("/panier"); }}
                className="border-2 border-[#1A1A18] px-8 py-4 font-mono-label hover:bg-[#1A1A18] hover:text-[#FAF8F3]"
                data-testid="product-buy-now"
              >
                Voir le panier
              </button>
            </div>

            {!product.in_stock && (
              <div className="mt-4 font-mono-label text-red-700">Rupture de stock</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
